import React from 'react';
export const Star = ({ icon }) => (
  <span
    css={`
      color: #e03546;
      font-size: 2.5rem;
      margin-left: 0.2rem;
      margin-top: -6px;
    `}
  >
    {icon}
  </span>
);
